import { render, staticRenderFns } from "./MainMenu.yaml?vue&type=template&id=08242cbd&component"
import script from "./MainMenu.yaml?vue&type=script&lang=ts&component"
export * from "./MainMenu.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports